/**
 * @fileoverview Landing page section showcasing the payments table.
 * @module features/landing/components/PaymentsSection
 */

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { LandingMonthStrip } from './LandingMonthStrip'
import { LandingPaymentsTable } from './LandingPaymentsTable'
import { LandingBusinessCostsCard } from './LandingBusinessCostsCard'

/**
 * Payments section for the landing page.
 * Displays a month strip and simplified payments table with mock data.
 *
 * @component
 */
export function PaymentsSection(): ReactElement {
  const { t } = useTranslation('features-landing')

  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold mb-4 text-foreground">
            {t('payments.title')}
          </h2>
        </div>

        {/* Month Strip (full width) */}
        <LandingMonthStrip />

        {/* 70/30 Layout */}
        <div className="flex flex-col lg:flex-row gap-10 mt-6">
          {/* 70% - Payments Table */}
          <div className="w-full lg:w-[70%] min-w-0">
            <div className="glass-card rounded-3xl px-6 pb-6">
              <LandingPaymentsTable />
            </div>
          </div>

          {/* 30% - Business Costs Card */}
          <div className="w-full lg:w-[30%]">
            <LandingBusinessCostsCard />
          </div>
        </div>
      </div>
    </section>
  )
}
